import React, { useState, useEffect } from "react";
import { DragDropContext, Droppable, Draggable } from "@hello-pangea/dnd";
import {
  Drawer,
  Typography,
  Box,
  Checkbox,
  List,
  ListItemIcon,
  ListItemText,
  IconButton,
  ListItemButton,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";

const dashboardWidgets = [
  { label: "Scheduled Work Order", id: 1 },
  { label: "Unscheduled Work Order", id: 2 },
  { label: "Total Work Request", id: 3 },
  { label: "New Work Request", id: 4 },
  { label: "Create Work Order", id: 5 },
  { label: "Create Work Reuest", id: 6 },
  { label: "Assets", id: 7 },
  { label: "Contract & License Details", id: 8 },
  { label: "Work Order Status", id: 9 },
  { label: "Assets By Work Groups", id: 10 },
  //{ label: "Disposed Assets", id: 11 },
  { label: "Workorder Status by Employee", id: 11 },
  //{ label: "Inventory", id: 12 },
  { label: "Work Order Inhouse VS Outsource", id: 12 },
 // { label: "Work Order By Category", id: 13 },
  { label: "Work Order Ageing", id: 13 },
 // { label: "Work Request Status", id: 14 },
  { label: "Department Work Request ", id: 14 },
 // { label: "Ontime And Overdue Chart", id: 15 },
  { label: "Asset Ageing", id: 15 },
  { label: "Open Closed Chart", id: 16 },
  { label: "Scheduled Unscheduled", id: 17 },
 // { label: "Total Work Request List", id: 18 },
  { label: "Total Work Order List", id: 18 },
  { label: "Work Request To Work Order", id: 19 },
 // { label: "Top Assets By WO Count", id: 20 },
 // { label: "Top Assets By Maintenance Cost", id: 21 },
  { label: "Work Order Complete To Authorised", id: 22 },

];

const WidgetDrawer = ({ open, onClose, selectedWidgets, onChange, widgetsOrder }) => {
  const [checked, setChecked] = useState(selectedWidgets || []);
  const [order, setOrder] = useState(widgetsOrder || dashboardWidgets.slice(0, 6).map((widget) => widget.id));
  const [widgets, setWidgets] = useState(dashboardWidgets);

  const fixedWidgets = widgets.slice(0, 6); // First four fixed widgets
  const draggableWidgets = widgets.filter((widget) => !fixedWidgets.includes(widget)); // Remaining draggable widgets

  // Sync checked state when selectedWidgets prop changes
  useEffect(() => {
    if (selectedWidgets) {
      setChecked(selectedWidgets);
    }
  }, [selectedWidgets]);

  // Sync order state when widgetsOrder prop changes
  useEffect(() => {
    if (widgetsOrder) {
      const orderedWidgets = dashboardWidgets
        .filter((widget) => widgetsOrder.includes(widget.id))
        .sort((a, b) => widgetsOrder.indexOf(a.id) - widgetsOrder.indexOf(b.id));
      setWidgets([...fixedWidgets, ...orderedWidgets]);
    }
  }, [widgetsOrder]);

  const handleToggle = (value) => () => {
    const currentIndex = checked.indexOf(value);
    const newChecked = [...checked];

    if (currentIndex === -1) {
      newChecked.push(value);
    } else {
      newChecked.splice(currentIndex, 1);
    }

    setChecked(newChecked);
    onChange({ newSelectedWidgets: newChecked, orderedWidgets: order }); // Notify parent about the change
  };

  const handleDragEnd = (result) => {
    if (!result.destination) return;

    // Reorder the draggable widgets based on the drag-and-drop result
    const reorderedWidgets = Array.from(draggableWidgets);
    const [removed] = reorderedWidgets.splice(result.source.index, 1);
    reorderedWidgets.splice(result.destination.index, 0, removed);

    // Update the widgets order
    const newOrder = [...fixedWidgets.map((w) => w.id), ...reorderedWidgets.map((w) => w.id)];
    setOrder(newOrder);
    setWidgets([...fixedWidgets, ...reorderedWidgets]);
    onChange({ newSelectedWidgets: checked, orderedWidgets: newOrder }); // Notify parent of new order
  };

  return (
    <Drawer
      open={open}
      disableScrollLock
      sx={{
        flexShrink: 0,
        "& .MuiDrawer-paper": {
          width: 300,
          boxSizing: "border-box",
          zIndex: 1600,
          borderLeft: "8px solid",
          borderColor: "primary.main",
        },
      }}
      anchor="right"
    >
      <Box sx={{ p: 2 }}>
        <Box display="flex" justifyContent="space-between" alignItems="center">
          <Typography variant="h6" component="div">
            Widgets
          </Typography>
          <IconButton onClick={onClose} size="small">
            <CloseIcon />
          </IconButton>
        </Box>

        {/* Fixed Widgets */}
        <List>
          {fixedWidgets.map((widget) => (
            <ListItemButton
              key={widget.id}
              dense
              onClick={handleToggle(widget.id)}
            >
              <ListItemIcon>
                <Checkbox
                  edge="start"
                  checked={checked.indexOf(widget.id) !== -1}
                  tabIndex={-1}
                  disableRipple
                  inputProps={{ "aria-labelledby": `checkbox-list-label-${widget.id}` }}
                />
              </ListItemIcon>
              <ListItemText
                id={`checkbox-list-label-${widget.id}`}
                primary={widget.label}
              />
            </ListItemButton>
          ))}
        </List>

        {/* Draggable Widgets */}
        <DragDropContext onDragEnd={handleDragEnd}>
          <Droppable droppableId="droppable">
            {(provided) => (
              <List {...provided.droppableProps} ref={provided.innerRef}>
                {draggableWidgets.map((widget, index) => (
                  <Draggable key={widget.id} draggableId={widget.id.toString()} index={index}>
                    {(provided) => (
                      <ListItemButton
                        ref={provided.innerRef}
                        {...provided.draggableProps}
                        {...provided.dragHandleProps}
                        dense
                        onClick={handleToggle(widget.id)}
                      >
                        <ListItemIcon>
                          <Checkbox
                            edge="start"
                            checked={checked.indexOf(widget.id) !== -1}
                            tabIndex={-1}
                            disableRipple
                            inputProps={{ "aria-labelledby": `checkbox-list-label-${widget.id}` }}
                          />
                        </ListItemIcon>
                        <ListItemText
                          id={`checkbox-list-label-${widget.id}`}
                          primary={widget.label}
                        />
                      </ListItemButton>
                    )}
                  </Draggable>
                ))}
                {provided.placeholder}
              </List>
            )}
          </Droppable>
        </DragDropContext>
      </Box>
    </Drawer>
  );
};

export default WidgetDrawer;
